import { render, staticRenderFns } from "./traffic-point.vue?vue&type=template&id=a3009f28&scoped=true&"
import script from "./traffic-point.vue?vue&type=script&lang=ts&"
export * from "./traffic-point.vue?vue&type=script&lang=ts&"
import style0 from "./traffic-point.vue?vue&type=style&index=0&id=a3009f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3009f28",
  null
  
)

export default component.exports